import { render, staticRenderFns } from "./SharingPage.vue?vue&type=template&id=b80fa1e6&scoped=true"
import script from "./SharingPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./SharingPage.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SharingPage.vue?vue&type=style&index=0&id=b80fa1e6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b80fa1e6",
  null
  
)

export default component.exports